import jsPDF from 'jspdf'; // eslint-disable-line import/no-named-as-default
import { applyPlugin } from 'jspdf-autotable';

applyPlugin(jsPDF);

const CONTENT_VERTICAL_OFFSET = 50;

export const stockManagerPdfGenerator = ({ tableId, headerContent, salonId, date, t }) => {
  // eslint-disable-next-line new-cap
  const doc = new jsPDF('p', 'pt');
  const res = doc.autoTableHtmlToJson(document.getElementById(tableId));
  const { height } = doc.internal.pageSize;

  doc.setFontSize(14);
  doc.setTextColor('#192340'); // dark blue

  headerContent?.forEach((content, index) => {
    const verticalOffset = CONTENT_VERTICAL_OFFSET + index * 20;
    const horizontalOffset = 45;
    doc.text(content, horizontalOffset, verticalOffset); // x, y
  });

  const normalizedColumns = [...res.columns.filter((column) => !!column)];

  const normalizedData = [
    // NOTE: we are filtering out the checkbox rows in the pdf generator
    ...res.data.map((rows) => rows.filter((row) => !row._element.className.includes('row-checkbox-'))),
  ];

  const headerContentLength = headerContent?.length;

  // If header content is present, we add the offset to the table vertical offset, otherwise we use the default offset
  const tableVerticalOffset = headerContentLength ? CONTENT_VERTICAL_OFFSET + headerContentLength * 20 : CONTENT_VERTICAL_OFFSET;

  doc.autoTable({
    head: [normalizedColumns],
    body: normalizedData,
    startY: tableVerticalOffset, //  startY: height, => start on new page
    theme: 'grid', // 'striped', 'grid' or 'plain
    font: 'helvetica', // helvetica, times, courier
    lineWidth: 0.5, // tbl border width
    fontStyle: 'normal', // normal, bold, italic, bolditalic
    // tableLineColor: 'red',
    // tableLineWidth: 1,
    halign: 'left', // left, center, right
    valign: 'middle', // top, middle, bottom
    fillStyle: 'F', // 'S', 'F' or 'DF' (stroke, fill or fill then stroke)
    columnWidth: 'auto', // 'auto', 'wrap' or a number
    headStyles: {
      cellPadding: 6,
      fontSize: 8.3, // px
      fillColor: '#FFFFFF', // brg pink
      textColor: '#192340', // dark blue
      lineColor: '#C8C7CC', // border
      lineWidth: 0.5, // tbl border width
      valign: 'middle',
    },
    styles: {
      fontSize: 8.8, // px
      cellPadding: 6,
      textColor: '#192340', // dark blue
      fillColor: 255, // tbl background
      lineColor: '#DFDFE0', // tbl border color
      valign: 'middle',
    },

    didDrawPage(data) {
      doc.setFontSize(10);
      doc.text(' ', 45, height - data.settings.margin.bottom - 10);
    },
  });

  doc.save(t('stocks.stockManagerPdf.fileName', { salonId, date }));
};
